import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {FUIChromeControlsService} from "../../chrome-controls.service";
import {FUIChromeControlComponent} from "../chrome-control.component";
import {Subscription} from "rxjs";

@Component({
    selector: "fui-chrome-control-link",
    templateUrl: "./chrome-control-link.component.html",
    styleUrls: ["./chrome-control-link.component.scss"]
})
export class FUIChromeControlLinkComponent extends FUIChromeControlComponent implements OnInit, OnDestroy {
    @Input() link: string;

    private subscriptions: Subscription = new Subscription();

    constructor(private chromeControlsService: FUIChromeControlsService) {
        super();
    }

    override ngOnInit() {
        this.chromeControlsService.generateId().then((id) => {
            this.id = id;

            this.subscriptions.add(this.chromeControlsService.activeControl$.subscribe(
                (id) => {
                    if (id) {
                        if (this.id === id) {
                            this.conflict = false;
                        }
                        else {
                            this.conflict = true;
                        }
                    }
                    else {
                        this.conflict = false;
                    }
                }
            ));
        });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
